// extracted by mini-css-extract-plugin
export default {"customDropDownSpacing":"gBeRyXpTUgPuQ2S17v8g","customModalSpacing":"SrcLqZcwR8QdzU47NRXg"};